// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import CheckAttachmentOrdersByBuildWeek from './checkAttachmentOrdersByBuildWeek';
import React from 'react';

function CheckAttachmentOrdersByBuildWeekPage () {

    return (
        <AuthenticatedPage className="atp-page atp-order-check-attachment-orders-by-build-week-page">
            <CheckAttachmentOrdersByBuildWeek />
        </AuthenticatedPage>
    );

}
CheckAttachmentOrdersByBuildWeekPage.displayNAme = 'CheckAttachmentOrdersByBuildWeekPage';

export default CheckAttachmentOrdersByBuildWeekPage;
